<template>
  <div>
    <div class="row">
      <div class="col-6 mt-4">
        <idx-card
          :title="`${this.$t('menu.settings.users.titleNewUser')}`"
          icon="user"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="user-name"
                  >{{ $t('menu.settings.users.labels.nameUser') }}:</label
                >
                <input
                  :disabled="true"
                  type="text"
                  v-model="user.name"
                  id="user-name"
                  class="form-control"
                  :placeholder="`${this.$t(
                    'menu.settings.users.placeholderNameUser',
                  )}`"
                  @keyup="removeInvalidClass('user-name')"
                />
                <div class="invalid-feedback">
                  {{ $t('menu.settings.users.invalidFeedbackName') }}
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-name">Email:</label>
                    <input
                      :disabled="true"
                      type="email"
                      v-model="user.email"
                      id="user-email"
                      class="form-control"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderEmailUser',
                      )}`"
                      @keyup="removeInvalidClass('user-email')"
                    />
                    <div class="invalid-feedback">
                      {{ $t('menu.settings.users.invalidFeedbackEmail') }}
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-name"
                      >{{ $t('menu.settings.users.labels.phone') }}:</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      v-model="user.phone"
                      id="user-phone"
                      class="form-control"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderPhoneUser',
                      )}`"
                      @keyup="removeInvalidClass('user-phone')"
                      v-mask="'+## (##) #####-####'"
                    />
                    <div class="invalid-feedback">
                      {{ $t('menu.settings.users.invalidFeedbackPhone') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-name"
                      >{{ $t('menu.settings.users.labels.post') }}:</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      v-model="user.position"
                      id="user-position"
                      class="form-control"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderPostUser',
                      )}`"
                      @keyup="removeInvalidClass('user-position')"
                    />
                    <div class="invalid-feedback">
                      {{ $t('menu.settings.users.invalidFeedbackPost') }}
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-profile"
                      >{{
                        $t('menu.settings.users.labels.viewingProfile')
                      }}:</label
                    >
                    <b-form-select
                      :disabled="true"
                      id="user-profile"
                      v-model="user.profile"
                      :options="options"
                    >
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ $t('menu.settings.users.invalidFeedbackProfile') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-name"
                      >{{
                        $t('menu.settings.users.labels.passwordUser')
                      }}:</label
                    >
                    <input
                      :disabled="true"
                      type="password"
                      v-model="user.password1"
                      @input="checkPassword"
                      id="user-password1"
                      class="form-control"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderPassUser',
                      )}`"
                      @keyup="removeInvalidClass('user-password2')"
                    />
                    <ul>
                      <span class="invalid-feedback">
                        <li>
                          {{
                            $t('menu.settings.users.invalidFeedbackSamePass')
                          }}
                        </li>
                      </span>
                      <span v-if="!contains_eight_characters">
                        <li class="invalid-password-user">
                          {{
                            $t('menu.settings.users.messages.eightCharacters')
                          }}
                        </li></span
                      >
                      <span v-if="!contains_number"
                        ><li class="invalid-password-user">
                          {{
                            $t('menu.settings.users.messages.containNumbers')
                          }}
                        </li>
                      </span>
                      <span v-if="!contains_uppercase"
                        ><li class="invalid-password-user">
                          {{
                            $t(
                              'menu.settings.users.messages.containCapitalLetters',
                            )
                          }}
                        </li>
                      </span>
                      <span v-if="!contains_special_character">
                        <li class="invalid-password-user">
                          {{
                            $t(
                              'menu.settings.users.messages.containSpecialCharacters',
                            )
                          }}
                        </li>
                      </span>
                    </ul>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="user-name"
                      >{{
                        $t('menu.settings.users.labels.repeatPassword')
                      }}:</label
                    >
                    <input
                      :disabled="true"
                      type="password"
                      v-model="user.password2"
                      id="user-password2"
                      class="form-control"
                      :placeholder="`${this.$t(
                        'menu.settings.users.placeholderPassUser',
                      )}`"
                      @keyup="removeInvalidClass('user-password2')"
                    />
                    <div class="invalid-feedback">
                      <ul>
                        <span
                          ><li>
                            {{
                              $t('menu.settings.users.invalidFeedbackSamePass')
                            }}
                          </li></span
                        >
                        <span v-if="!contains_eight_characters">
                          <li>
                            {{
                              $t('menu.settings.users.messages.eightCharacters')
                            }}
                          </li>
                        </span>
                        <span v-if="!contains_number">
                          <li>
                            {{
                              $t('menu.settings.users.messages.containNumbers')
                            }}
                          </li>
                        </span>
                        <span v-if="!contains_uppercase">
                          <li>
                            {{
                              $t(
                                'menu.settings.users.messages.containCapitalLetters',
                              )
                            }}
                          </li>
                        </span>
                        <span v-if="!contains_special_character">
                          <li>
                            {{
                              $t(
                                'menu.settings.users.messages.containSpecialCharacters',
                              )
                            }}
                          </li>
                        </span>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="userAuth.companyList && userAuth.companyList.length > 1"
                class="row"
              >
                <div class="col-6">
                  <div class="form-group">
                    <label for="modal-user-company">
                      {{ $t('menu.settings.users.labels.company') }}:
                    </label>
                    <select
                      :disabled="true"
                      class="form-control"
                      multiple
                      id="modal-user-company"
                      v-model="selectedCompanies"
                    >
                      <option
                        v-for="(item, i) in companiesOptions"
                        :value="item.value"
                        :key="i"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mt-4 text-right">
                <b-alert show variant="warning" class="text-left">
                  <h6>Criação de novos usuários devem ser feitas na nova versão da INDECX</h6>
                </b-alert>
                <button @click="getV3" class="btn btn-primary">Ir para nova versão </button>

                <!-- <button @click="sendNewUser" class="btn btn-primary">
                  {{ $t('menu.settings.users.buttonRegister') }}
                </button> -->
              </div>
            </div>
          </div>
        </idx-card>
      </div>
      <div class="col-6 mt-4">
        <div class="row">
          <div class="col-7">
            <div class="search-users">
              <input
                type="text"
                class="form-control"
                id="input-compnay-users"
                :placeholder="`${this.$t(
                  'menu.settings.users.placeholderSearch',
                )}`"
                v-model="filter"
                @keyup="searchUsers"
              />

              <button
                class="btn btn-outline-primary"
                :title="`${this.$t('menu.settings.users.clear')}`"
                @click="cleanFilter"
              >
                {{ $t('menu.settings.users.clear') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <b-table
              striped
              :items="myUsers.users"
              :fields="fields"
              :busy="loading"
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
              </template>
              <template v-slot:cell(company)="row">
                {{ returnCompanyName() }}
                {{ hasCompanyList(row.item._id) }}
              </template>
              <template v-slot:cell(lastLogin)="row">
                {{ row.item.lastLogin ? dateFormat(row.item.lastLogin) : '-' }}
              </template>
              <template v-slot:cell(options)="row">
                <div class="buttons-area" style="min-width: 90px;">
                  <button
                    v-b-modal="`edit-user-${row.item._id}`"
                    class="btn btn-outline-primary"
                  >
                    <font-awesome-icon :icon="['fas', 'pen']" />
                  </button>
                  <button
                    class="btn btn-outline-danger"
                    @click="removeUser(row.item._id, row.item.name)"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-alt']" />
                  </button>
                </div>
                <modal-edit-user
                  :id="row.item._id"
                  :myUser="row.item"
                  :filter="filter"
                  :page="page"
                  :limit="limit"
                />
              </template>
            </b-table>
            <div v-show="!loading" class="pagination-area-config-users">
              <paginate
                v-model="page"
                :pageCount="Math.ceil(myUsers.total / 5)"
                :clickHandler="updateTable"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              >
              </paginate>
            </div>
            <div class="col-12 text-right">
              <div class="loader">
                <b-spinner
                  v-if="loadingPdf"
                  class="spinner-border"
                  label="Spinning"
                ></b-spinner>

                <a @click="exportToXLS" title="Exportar para XLS">
                  <span class="xls">
                    <i class="fas fa-file-excel"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import XLSX from 'xlsx';
import { lightFormat } from 'date-fns';
import validator from 'validator';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import api from '@/services/api';
import ModalEditUser from '../modal-edit-user';

export default {
  components: {
    ModalEditUser,
    Paginate,
    IdxCard,
  },

  data: () => ({
    userAuth: null,
    typingTimer: 0,
    filter: null,
    page: 1,
    limit: 5,
    options: [],
    user: {
      name: null,
      email: null,
      formattedPhone: null,
      phone: null,
      position: null,
      password1: null,
      password2: null,
      profile: '0',
    },
    loading: true,
    fields: [],
    items: [],
    userActive: [],
    totalUsers: '',
    idUser: '',
    password_length: 0,
    contains_eight_characters: true,
    contains_number: true,
    contains_uppercase: true,
    contains_special_character: true,
    valid_password: true,
    companiesOptions: [],
    selectedCompanies: [],
    currentCompanyList: [],
    loadingPdf: false,
    companyName: '',
  }),

  computed: {
    ...mapState('settings', ['myUsers', 'getAllUsers']),
    ...mapState('master', ['allCompanies']),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getAllCompanies({
      token: this.userAuth.token,
      justIds: false,
    });
    for (let i = 1; i < this.allCompanies.length; i += 1) {
      if (this.userAuth.companyId === this.allCompanies[i].value) {
        this.companyName = this.allCompanies[i].text;
      }
    }
    if (this.userAuth.companyList && this.userAuth.companyList.length > 1) {
      for (let i = 1; i < this.allCompanies.length; i += 1) {
        if (
          this.userAuth.companyId === this.allCompanies[i].value
        ) {
          this.companiesOptions.push(this.allCompanies[i]);
        }
      }
    } else {
      for (let i = 1; i < this.allCompanies.length; i += 1) {
        if (this.userAuth.companyId === this.allCompanies[i].value) {
          this.companiesOptions.push(this.allCompanies[i]);
        }
      }
      this.selectedCompanies.push(this.userAuth.companyId);
      this.currentCompanyList.push(this.userAuth.companyId);
    }

    this.fields = [
      { key: 'name', label: this.$t('menu.settings.users.labels.user') },
      { key: 'occupation', label: this.$t('menu.settings.users.labels.post') },
      { key: 'company', label: this.$t('menu.settings.users.labels.company') },
      {
        key: 'lastLogin',
        label: this.$t('menu.settings.users.labels.lastLogin'),
      },
      { key: 'options', label: this.$t('menu.settings.users.labels.options') },
    ];
  },

  async mounted() {
    await Promise.all([this.updateTable(), this.getProfiles()]);
  },

  methods: {
    ...mapActions('settings', ['getUsers', 'registerUser', 'deleteUser']),
    ...mapActions('master', ['getAllCompanies']),

    splitCompanyList() {

      const newCompanyList = this.selectedCompanies.filter((company) => {
        return !this.currentCompanyList.includes(company);
      });

      const removedCompanyList = this.currentCompanyList.filter((company) => {
        return !this.selectedCompanies.includes(company);
      });

      return {
        newCompanyList,
        removedCompanyList,
      };

    },

    returnCompanyName() {
      return this.companyName;
    },

    async exportToXLS() {
      const header = [
        'Nome',
        'Cargo',
        'Email',
        'Empresa',
        'Último Acesso',
        'Perfil',
        'Ih1',
      ];

      const arr = [];

      let data = [];

      this.loadingPdf = true;

      try {
        const response = await api.get(
          `/users-profile/${this.userAuth.companyId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        data = response.data;
      } catch (error) {
        window.console.log(error);
      }

      data.usersList.forEach((el) => {
        arr.push({
          Nome: el.name,
          Cargo: el.occupation,
          Empresa: el.company,
          Email: el.email,
          'Último Acesso': el.lastLogin,
          Perfil: el.profile,
          Ih1: el.ih1,
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('usuarios');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      wb.Sheets.usuarios = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'usuarios.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);

      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;

      this.loadingPdf = false;

      return buf;
    },

    async updateTable() {
      this.loading = true;

      await this.getUsers({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        userId: this.userAuth._id,
        page: this.page,
        limit: this.limit,
        filter: this.filter,
        hideIndecxUsers: true,
      });

      this.loading = false;
    },

    async getProfiles() {
      const response = await api.get(`/profiles/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.options.push({
        value: '0',
        text: this.$t('menu.settings.users.chooseOption'),
      });

      response.data.forEach((el) => {
        this.options.push({ value: el._id, text: el.name });
      });
    },

    searchUsers() {
      if (this.filter) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      } else if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
    },

    cleanFilter() {
      if (this.filter) {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'H:mm');
      return `${day} às ${hour}`;
    },

    getV3() {
      const token = this.userAuth.token;
      const host = window.location.host;
      const url = (host.includes('indecx.pe')) ? `https://stg.app-indecx.com/redirect/${token}` : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },

    async sendNewUser() {
      if (this.validateFields()) {
        const response = await api.get(`user/verify/active`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            email: this.user.email,
          },
        });

        if (response.data.found && this.valid_password) {
          swal({
            title:
              'Esse usuário já estava cadastrado na base com status INATIVO',
            text: 'Deseja reativar o cadastro?',
            icon: 'warning',
            buttons: ['Cancelar', 'Reativar'],
          }).then(async (yes) => {
            if (yes) {
              api.put(
                `user/${response.data.userId}`,
                {
                  companyId: this.userAuth.companyId,
                  name: this.user.name,
                  email: this.user.email,
                  password: this.user.password2,
                  profileId: this.user.profile,
                  occupation: this.user.position,
                  celPhone: this.formattedPhone,
                  active: true,
                  companyList: this.selectedCompanies,
                  newCompanyList: this.splitCompanyList().newCompanyList,
                  removedCompanyList: this.splitCompanyList().removedCompanyList,
                },
                {
                  headers: { 'x-access-token': this.userAuth.token },
                },
              );
              this.updateTable();
            }
          });
        } else if (this.valid_password) {
          this.registerUser({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            user: {
              companyId: this.userAuth.companyId,
              name: this.user.name,
              email: this.user.email,
              password: this.user.password2,
              profileId: this.user.profile,
              occupation: this.user.position,
              celPhone: this.formattedPhone,
              companyList: this.selectedCompanies,
              newCompanyList: this.selectedCompanies,
              removedCompanyList: [],
              createdBy: this.userAuth._id,
              updatedBy: this.userAuth._id,
            },
          })
            .then(() => {
              this.user.name = null;
              this.user.email = null;
              this.user.phone = null;
              this.user.position = null;
              this.user.profile = '0';
              this.user.password1 = null;
              this.user.password2 = null;
              this.loading = true;
              this.updateTable();
              swal({
                title: this.$t(
                  'menu.settings.users.messages.registerUser.text',
                ),
                text: this.$t(
                  'menu.settings.users.messages.registerUser.description',
                ),
                icon: 'success',
              });
            })
            .catch((error) => {
              swal({
                title: this.$t('menu.settings.users.messages.error'),
                text: `${error.response.data.message}`,
                icon: 'warning',
              });
            });
        } else {
          swal({
            title: this.$t('menu.settings.users.messages.incorrectData.title'),
            text: this.$t(
              'menu.settings.users.messages.incorrectData.description',
            ),
            icon: 'warning',
          });
        }
      }
    },

    validateFields() {
      if (!this.user.name) {
        document.getElementById('user-name').classList.add('is-invalid');
        return false;
      } else if (
        !this.user.email ||
        validator.isEmail(this.user.email) === false
      ) {
        document.getElementById('user-email').classList.add('is-invalid');
        return false;
      } else if (!this.user.position) {
        document.getElementById('user-position').classList.add('is-invalid');
        return false;
      } else if (this.user.profile === '0') {
        document.getElementById('user-profile').classList.add('is-invalid');
        return false;
      } else if (!this.user.password1) {
        document.getElementById('user-password1').classList.add('is-invalid');
        return false;
      } else if (
        !this.user.password2 ||
        this.user.password1 !== this.user.password2
      ) {
        document.getElementById('user-password2').classList.add('is-invalid');
        return false;
      } else if (this.selectedCompanies.length === 0) {
        document
          .getElementById('modal-user-company')
          .classList.add('is-invalid');
        return false;
      }

      // if (!this.formatNumber()) {
      //   return false;
      // }

      return true;
    },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },

    removeUser(id, name) {
      swal({
        title: this.$t('menu.settings.users.messages.deleteUser.text'),
        text: this.$t('menu.settings.users.messages.deleteUser.description', {
          name: `${name}`,
        }),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          this.deleteUser({
            token: this.userAuth.token,

            loggedUser: this.userAuth._id,
            userId: id,
          }).then(() => {
            this.updateTable();
          });
        }
      });
    },

    checkPassword() {
      this.password_length = this.user.password1.length;

      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.user.password1);
      this.contains_uppercase = /[A-Z]/.test(this.user.password1);
      this.contains_special_character = format.test(this.user.password1);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    hasCompanyList(userId) {
      for (let i = 0; i < this.myUsers.users.length; i += 1) {
        if (this.myUsers.users[i]._id === userId) {
          if (
            this.myUsers.users[i].companyList &&
            this.myUsers.users[i].companyList.length > 1
          ) {
            return ' +';
          }
        }
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.spinner-border {
  color: #4ce595;
  width: 1.5rem;
  height: 1.5rem;
}

.loader {
  background-color: #fff;
  display: block;
}

.search-users {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.header {
  background-color: #72bcd4;
  color: #fff;
  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.body {
  padding: 20px;
  border: 1px solid #ccc;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.pagination-area-config-users >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}
</style>

<style>
.pagination-area-config-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-config-users a {
  outline: none;
}

.invalid-password-user {
  font-size: 80%;
  color: #d50000;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/config-users/index.vue